// extracted by mini-css-extract-plugin
module.exports = {"buttonHolder":"SpeakerSettings_buttonHolder__zGsHD","speakerSettingsHolder":"SpeakerSettings_speakerSettingsHolder__2qcmg"};